import { Grid } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import ControlService from "./ConsultControlService";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import DefaultChip from "../../componentes/chip/DefaultChip";
import { Typography } from "@mui/material";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";

const columns = (t) => [
    {
        field: "id",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="id" />;
        },
    },
    {field: "idClient", visible:false},
    {
        field: "clientName",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="clientName" name="company" />;
        },
    },
    {
        field: "numberDocument",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="numberDocumentPicking" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.numberDocument}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "dtDocument",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="dtDocument" />;
        },
    },
    {
        field: "dtSend",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="dtSend" />;
        },
    },
    {field:"cdStatus", visible: false},
    {
        field: "cdStatusDesc",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        template: (props) => {
            let chipStyle;

            switch (props.cdStatus) {
                case 1:
                    chipStyle = "progress";
                    break;
                case 2:
                    chipStyle = "finished";
                    break;
                case 3:
                    chipStyle = "canceled";
                    break;
                default:
                    chipStyle = "grey";
                    break;
            }

            return (
                <>
                
                    <DefaultChip
                        style={chipStyle}
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.cdStatusDesc}
                        </Typography>}
                    />
                </>
            )
        }
    },
];

const columnsProduct = (t) => [
    {
        field: "idProduct",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="idProduct" />;
        },
    },
    {
        field: "productCode",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="productCode" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.productCode}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "productName",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="productName" />;
        },
    },
    {
        field: "quantityUnit",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="qtdeUnit" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.quantityUnit}
                        </Typography>}
                    />
                </>
            )
        }
    },
];

export const ConsultOutput = () => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: "",
        numberDocument: "",
        idClient: "",
        codigoClient: "", // somente para visualizar na tela
        clientName: "",
        dtDocument: null,
        dtSend: null,
        rows: [],
        rowsProduct: [],
        userId: userId,
        cdStatus: 1,
        success: false,
        error: false,
        selectedClient: null,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const { id, numberDocument, dtDocument, dtSend, idClient, codigoClient, clientName, cdStatus} = state
    const { success, error, rows, rowsProduct, ...data } = state

    const handleChange = ({ target: { name, value } }) => {
        
        if (name === "idClient")
        {
            if (value === 0)
            {
                dispatch({ type: 'update', data: { [name]: value, codigoClient: ""  } }) 
            }
            else
            {
                dispatch({ type: 'update', data: { [name]: value, codigoClient: value  } }) 
            }
        }
        else{
            dispatch({ type: 'update', data: { [name]: value } }) 
        }
    }

    const handleCancel = () => {
        ControlService
            .cancelOutput(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'success' })
                    dispatch({ type: 'clear' })
                }
            })
            .catch((e) => dispatch({ type: 'error' }));
    }

    const handleSearch = () => {

        let request = { ...state };

        if (request.id) {
            request.id = parseInt(request.id, 10);
        } else {
            delete request.id; // ou delete request.id;
        }
        if (request.idClient) {
            request.idClient = parseInt(request.idClient, 10);
        } else {
            delete request.idClient; // ou delete request.id;
        }

        if (request.dtDocument instanceof Date) {
            const d = request.dtDocument;
            request.dtDocument = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T00:00:00`;
        } else {
            delete request.dtDocument;
        }

        if (request.dtSend instanceof Date) {
            const d = request.dtSend;
            request.dtSend = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T00:00:00`;
        } else {
            delete request.dtSend;
        }
        console.log(request);
        debugger;
        ControlService
            .filterOutput(request)
            .then((response) => {
                if (response.status === 200) {

                    const data = response.data.map(item => ({
                        ...item,
                        dtDocumentOriginal: item.dtDocument ? new Date(item.dtDocument) : null, // para picker
                        dtDocument: item.dtDocument 
                            ? new Date(item.dtDocument).toLocaleDateString('pt-BR') // para grid
                            : '',
                        dtSendOriginal: item.dtSend ? new Date(item.dtSend) : null, // para picker
                        dtSend: item.dtSend 
                            ? new Date(item.dtSend).toLocaleDateString('pt-BR') // para grid
                            : ''
                    }));

                    dispatch({ type: 'update', data: { rows: data } });
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }

    const handleCellClick = (rowData) => {
        
        dispatch({
            type: 'update', data: {
                id: rowData.id,
                numberDocument: rowData.numberDocument,
                idClient: rowData.idClient,
                codigoClient: rowData.idClient,
                clientName: rowData.clientName,
                dtDocument: rowData.dtDocumentOriginal,
                dtSend: rowData.dtSendOriginal,
                cdStatus: rowData.cdStatus // <-- guardando no state
            }
        })

        const request = { idOutputProduct: rowData.id };

        ControlService
            .getByIdOutput(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rowsProduct: response.data } });
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rowsProduct: [] } }));

    }

    const handleExport = () => {
        
        var dados = '';
        dados += "\n"
        dados += "Packing\n"
        dados += `Número do Documento: ${state.numberDocument}\n`;

        let dtDoc = ""
        const dateDoc = new Date(state.dtDocument);
        const diaDoc = String(dateDoc.getDate()).padStart(2, '0');
        const mesDoc = String(dateDoc.getMonth() + 1).padStart(2, '0');
        const anoDoc = dateDoc.getFullYear();
        dtDoc = `${diaDoc}/${mesDoc}/${anoDoc}`;
        dados += `Data do Documento: ${dtDoc}\n`;

        let dtSend = ""
        const dateSend = new Date(state.dtSend);
        const diaSend = String(dateSend.getDate()).padStart(2, '0');
        const mesSend = String(dateSend.getMonth() + 1).padStart(2, '0');
        const anoSend = dateSend.getFullYear();
        dtSend = `${diaSend}/${mesSend}/${anoSend}`;
        
        dados += `Data de Envio Programada: ${dtSend}\n`;
        dados += `Nome do Cliente: ${state.clientName}\n\n`;

        dados += "Cód. Produto; Descrição Produto; Qtde. Unitária;\n"
        
        rowsProduct.map((item) => {

            dados += `${item.productCode};${item.productName};${item.quantityUnit}; \n`;
            
        })

        const blob = new Blob([dados], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.download = `Exportação_Packing.csv`;

        link.href = url;
        link.click();
    };

    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                name="id"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={id}
                                labelName={"idDocument"}
                                inputProps={{ maxLength: 20 }}
                                error={error && id === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="description" labelName="numberDocument" />
                                }
                                name="numberDocument"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={numberDocument}
                                inputProps={{ maxLength: 20 }}
                                error={error && numberDocument === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <CustomDatePicker
                                id="dtDocument"
                                name="dtDocument"
                                selectedDate={dtDocument}
                                handleChange={handleChange}
                                error={error && dtDocument === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <CustomDatePicker
                                id="dtSend"
                                name="dtSend"
                                selectedDate={dtSend}
                                handleChange={handleChange}
                                error={error && dtSend === ""}
                            />
                        </Grid>
                        
                    </GridInputRow>

                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                name="codigoClient"
                                control={control}
                                defaultValue="codigoClient"
                                onChange={handleChange}
                                value={codigoClient}
                                labelName={"idClient"}
                                inputProps={{ maxLength: 20 }}
                                error={error && codigoClient === ""}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <DefaultAutocomplete
                                iconLabelSwitch={
                                    <IconLabelSwitch name="company" labelName="client" />
                                }
                                name={"idClient"}
                                onChange={handleChange}
                                value={idClient}  // <--- usa o objeto completo
                                label={t("clientName")}
                                defaultSize
                                useApi
                                endpoint='GetClient'
                            />
                        </Grid>
                    </GridInputRow>

                    <SearchClearSaveRow
                        {...(rowsProduct.length > 0 && cdStatus === 1 && {
                            onDefaultClick: handleCancel, labelName:t("cancelPicking")
                        })}
                        {...(rowsProduct.length <= 0 && {
                            onClickSearch: handleSearch
                        })}
                        onClickClear={() => dispatch({ type: 'clear' })}
                        {...(rowsProduct.length > 0 && {
                            onClickExport: handleExport
                        })}
                    />
                    {(rows.length > 0 && rowsProduct.length === 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columns(t)}
                                    dataSource={rows}
                                    allowPaging={true}
                                    cellSelected={(args, grid) =>
                                        handleCellClick(args.data)
                                    } />
                                    
                            </Grid>
                        </GridInputRow>
                    ) : null}
                    {(rowsProduct.length > 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columnsProduct(t)}
                                    allowPaging={true}
                                    dataSource={rowsProduct}
                                />
                            </Grid>
                        </GridInputRow>
                    ) : null}
                </GridItemContainer>
            } />
    );
}